import React from 'react';

import { Link } from 'gatsby';
import FancyTitle from '../fancy-title';

const sliderLogoWidth = 144;

function PartnerLogo({ partners, partner, index }) {
  return (
    <div
      className={`pointer-events-none${
        index === partners.length - 1 ? ' pr-12' : ''
      }`}
    >
      {partner.filename ? (
        <img
          src={partner.filename}
          width={partner.logoWidth}
          height={partner.logoHeight}
          className="w-[var(--slider-logo-width)] max-h-12 invert dark:invert-0"
          style={{ '--slider-logo-width': `${sliderLogoWidth}px` }}
          alt={partner.alt}
          loading="lazy"
        />
      ) : (
        <h4>{partner.title}</h4>
      )}
    </div>
  );
}

export default function PartnerLogos({ blok }) {
  if (!blok.blocks.length) {
    return null;
  }

  const titleBlock = blok.blocks.find((item) => item.component === 'Headlines');
  const even = blok?.first_row?.map(
    (row) => ({ image: row.image[0], url: row.url, uid: row._uid }),
  ) || [];
  const odd = blok?.second_row?.map(
    (row) => ({ image: row.image[0], url: row.url, uid: row._uid }),
  ) || [];

  const slideShowWidths = [
    even.length * (sliderLogoWidth + 32),
    odd.length * (sliderLogoWidth + 32),
  ];

  return (
    <div className="px-4 lg:px-16">
      {titleBlock && (
        <FancyTitle
          text={titleBlock.headline}
          className="text-center my-10"
          tag="h2"
          subtitle={titleBlock.subline}
          textAlign="lg:text-center"
          marginBottom="mb-20"
        />
      )}

      {[even, odd].map((slider, i) => (
        <div
          key={`even-odd-${slider.uid}-${i}`}
          className="overflow-hidden slideshow my-8"
          style={{ '--slideshow-width': `-${slideShowWidths[i]}px` }}
        >
          <div className="slideshow-track flex flex-row">
            {[1, 2, 3].map((count) => (
              <div key={`track-loop-${count}`}>
                <div
                  className="flex items-center gap-8 mr-8"
                  style={{ width: `${slideShowWidths[i]}px` }}
                >
                  {slider.map((item, index) => {
                    const partner = item;
                    const partnerLogo = (
                      <PartnerLogo
                        partner={item.image}
                        index={index}
                        key={item.image.id}
                        partners={[even, odd]}
                      />
                    );

                    return partner.url.story ? (
                      <Link to={partner.url.story?.full_slug ? `/${partner.url.story?.full_slug}` : ''} key={partner.title}>
                        {partnerLogo}
                      </Link>
                    ) : (
                      partnerLogo
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
